<span
	*ngIf="showClearButton"
	(click)="onClearSearchClicked()"
	[class]="spanStateClass"
	class="cup mdi mdi-18px position-absolute px-2 text-muted"
	style="top: 3px; left: 0"></span>
<input
	data-cy="layout-search-input"
	#searchInput
	autofocus
	autocomplete="off"
	[formControl]="searchInputControl"
	type="text"
	[placeholder]="placeHolder"
	class="form-control pe-5"
	id="searchInputControl"
	[value]="selectedSymbolName"
	(keydown.arrowup)="arrowup()"
	(keydown.arrowdown)="arrowdown()"
	(keydown.enter)="enter($event)" />
<span
	class="text-danger d-block small mt-1"
	*ngIf="
		showNothingFoundText &&
		spanStateClass === spanStates.close &&
		!(searchResult.length !== 0 || searchResultByCategorySplited.size !== 0) &&
		searchInput.value.length > 0
	"
	>نتیجه‌ای یافت نشد!</span
>
